import React, { useState } from "react";
import { C, RFLogo } from "../theme";
import { fmt, fmtD, Kpi, Btn, getAppCopy } from "../shared";
import { PLANS, AD_CAMPAIGNS, API_KEYS_DEMO, WEBHOOK_EVENTS } from "../data";

export const AdminPortal = ({ locale = "fr", providerRequests = [], residents = [], prestataires = [], onApproveProvider, onRejectProvider, onLogout }) => {
  const copy = getAppCopy(locale);
  const [tab, setTab] = useState("dashboard");
  const [webhookLog, setWebhookLog] = useState([
    {id:1,event:"paiement.reçu",url:"https://api.client.ma/hooks",statut:"200 OK",ts:"14:32:01"},
    {id:2,event:"maintenance.créée",url:"https://api.client.ma/hooks",statut:"200 OK",ts:"13:58:44"},
    {id:3,event:"cotisation.impayée",url:"https://api.client.ma/hooks",statut:"503 Error",ts:"11:20:09"},
  ]);

  const subscribers = [
    ...residents.map((item) => ({ id: `r-${item.id}`, type: "Copropriétaire", name: `${item.prenom} ${item.nom}`, email: item.email })),
    ...prestataires.map((item) => ({ id: `p-${item.id}`, type: "Prestataire", name: item.nom, email: item.email, plan: item.plan })),
  ];

  const tabs = [
    { key: "dashboard",   label: "Dashboard",         icon: "📊" },
    { key: "ads",         label: "Revenus Publicitaires", icon: "📢" },
    { key: "providers",   label: "Prestataires",      icon: "🛡️" },
    { key: "subscribers", label: "Utilisateurs",      icon: "👥" },
    { key: "dev",         label: "API & Dev",         icon: "⚙️" },
  ];

  const totalAdRev = AD_CAMPAIGNS.reduce((a,c) => a + c.revenus, 0);
  const activeAds  = AD_CAMPAIGNS.filter(c => c.statut === "actif").length;

  return (
    <div style={{minHeight:"100vh",background:C.bg}}>
      <div style={{background:C.navy,height:62,display:"flex",alignItems:"center",justifyContent:"space-between",padding:"0 34px",boxShadow:"0 2px 20px rgba(11,19,51,.22)"}}>
        <div style={{display:"flex",alignItems:"center",gap:12}}>
          <RFLogo size={34} />
          <div>
            <p style={{fontFamily:"Syne",fontWeight:800,color:"#fff",fontSize:15,lineHeight:1}}>RésiFlow</p>
            <p style={{color:"rgba(255,255,255,.35)",fontSize:11}}>{copy.adminWorkspace}</p>
          </div>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:12}}>
          <div style={{background:"rgba(14,201,164,.15)",borderRadius:10,padding:"6px 14px",display:"flex",alignItems:"center",gap:6}}>
            <div style={{width:7,height:7,borderRadius:"50%",background:C.teal}} />
            <span style={{color:C.teal,fontSize:12,fontWeight:700}}>Cloud · Cloudflare Workers</span>
          </div>
          <Btn onClick={onLogout} outline style={{color:"#fff",border:"1px solid rgba(255,255,255,.25)"}}>{copy.logout}</Btn>
        </div>
      </div>

      <div style={{padding:"26px 34px"}}>
        <div style={{display:"flex",gap:4,marginBottom:24,background:C.card,padding:5,borderRadius:13,width:"fit-content",boxShadow:"0 2px 10px rgba(11,19,51,.05)"}}>
          {tabs.map((tabItem) => (
            <button key={tabItem.key} className="btn" onClick={() => setTab(tabItem.key)}
              style={{padding:"7px 16px",borderRadius:9,fontSize:13,fontWeight:600,background:tab===tabItem.key?C.teal:"transparent",color:tab===tabItem.key?"#fff":C.muted,
              display:"inline-flex",alignItems:"center",gap:5}}>
              {tabItem.icon} {tabItem.label}
              {tabItem.key==="providers" && providerRequests.length>0 && <span style={{background:C.red,color:"#fff",borderRadius:"50%",width:16,height:16,display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:9,fontWeight:700}}>{providerRequests.length}</span>}
            </button>
          ))}
        </div>

        {/* ── DASHBOARD ── */}
        {tab === "dashboard" && (
          <div className="fi">
            <div style={{background:`linear-gradient(135deg,${C.navy},#1e3080)`,borderRadius:16,padding:24,marginBottom:20,display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:0}}>
              {[
                {label:"MRR",        value:"52 300 MAD", sub:"+12% ce mois",     color:C.teal},
                {label:"ARR",        value:"627 600 MAD",sub:"Projection annuelle",color:C.gold},
                {label:"Rev. Pub.",  value:fmt(totalAdRev),sub:`${activeAds} campagnes actives`,color:"#a78bfa"},
                {label:"Churn",      value:"4.2%",       sub:"−1.3% vs mois préc.",color:"#ff9090"},
              ].map((m,i) => (
                <div key={m.label} style={{padding:"8px 20px",borderRight:i<3?"1px solid rgba(255,255,255,.1)":"none",textAlign:"center"}}>
                  <p style={{color:"rgba(255,255,255,.4)",fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:".5px",marginBottom:8}}>{m.label}</p>
                  <p style={{color:m.color,fontSize:22,fontWeight:800,fontFamily:"Syne",marginBottom:4}}>{m.value}</p>
                  <p style={{color:"rgba(255,255,255,.35)",fontSize:11}}>{m.sub}</p>
                </div>
              ))}
            </div>

            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14,marginBottom:20}}>
              <Kpi icon="🏢" label="Syndics actifs"      value="3"                  color={C.blue}  />
              <Kpi icon="👥" label="Copropriétaires"     value={residents.length}   color={C.green} />
              <Kpi icon="🔧" label="Prestataires"        value={prestataires.length} color={C.gold} />
              <Kpi icon="⏳" label="Demandes en attente" value={providerRequests.length} color={C.red} />
            </div>

            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:18}}>
              {/* Conversion funnel */}
              <div style={{background:C.card,borderRadius:16,padding:22,boxShadow:"0 2px 14px rgba(11,19,51,.06)"}}>
                <h4 style={{fontSize:14,fontWeight:700,color:C.text,marginBottom:16}}>🎯 Funnel de conversion</h4>
                {[
                  {label:"Visiteurs uniques",  n:"1 248", pct:100, color:C.blue},
                  {label:"Inscrits",            n:"312",   pct:25,  color:C.teal},
                  {label:"Essais activés",      n:"87",    pct:7,   color:C.gold},
                  {label:"Payants actifs",      n:"34",    pct:2.7, color:C.green},
                ].map(f => (
                  <div key={f.label} style={{marginBottom:12}}>
                    <div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}>
                      <span style={{fontSize:13,color:C.text,fontWeight:600}}>{f.label}</span>
                      <span style={{fontSize:13,fontWeight:700,color:f.color}}>{f.n} <span style={{fontSize:11,color:C.muted,fontWeight:400}}>({f.pct}%)</span></span>
                    </div>
                    <div style={{height:8,background:C.bg,borderRadius:4,overflow:"hidden"}}>
                      <div style={{height:"100%",background:f.color,width:`${f.pct}%`,borderRadius:4}} />
                    </div>
                  </div>
                ))}
              </div>

              {/* Revenue breakdown */}
              <div style={{background:C.card,borderRadius:16,padding:22,boxShadow:"0 2px 14px rgba(11,19,51,.06)"}}>
                <h4 style={{fontSize:14,fontWeight:700,color:C.text,marginBottom:16}}>💰 Revenus par source</h4>
                {[
                  {src:"Abonnements prestataires", rev:"7 466 MAD/mois", pct:88, color:C.teal},
                  {src:"Publicité Google Ads",      rev:fmt(totalAdRev)+" /mois", pct:12, color:"#a78bfa"},
                  {src:"Commissions marketplace",   rev:"Bientôt",       pct:0,  color:C.gold},
                ].map(r => (
                  <div key={r.src} style={{marginBottom:14}}>
                    <div style={{display:"flex",justifyContent:"space-between",marginBottom:5}}>
                      <span style={{fontSize:13,fontWeight:600,color:C.text}}>{r.src}</span>
                      <span style={{fontSize:12,color:r.color,fontWeight:700}}>{r.rev}</span>
                    </div>
                    <div style={{height:6,background:C.bg,borderRadius:3,overflow:"hidden"}}>
                      <div style={{height:"100%",background:r.color,width:`${r.pct}%`,borderRadius:3}} />
                    </div>
                  </div>
                ))}
                <div style={{background:C.bg,borderRadius:10,padding:"10px 14px",marginTop:8,display:"flex",justifyContent:"space-between"}}>
                  <span style={{fontSize:13,fontWeight:700,color:C.text}}>Total mensuel</span>
                  <span style={{fontSize:14,fontWeight:800,color:C.green}}>{fmt(7466 + totalAdRev)}</span>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ── ADS REVENUE ── */}
        {tab === "ads" && (
          <div className="fi">
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14,marginBottom:20}}>
              <Kpi icon="📢" label="Campagnes actives" value={activeAds}             color={C.blue}   delay={0} />
              <Kpi icon="👁️" label="Impressions totales" value={AD_CAMPAIGNS.reduce((a,c)=>a+c.impressions,0).toLocaleString()} color={C.teal} delay={60} />
              <Kpi icon="💵" label="Revenus ce mois"   value={fmt(totalAdRev)}       color={C.green}  delay={120} />
            </div>

            {/* How ads work */}
            <div style={{background:`linear-gradient(135deg,${C.navy},#1a2b7a)`,borderRadius:16,padding:22,marginBottom:20}}>
              <h4 style={{color:"#fff",fontSize:15,fontWeight:700,marginBottom:14}}>📢 Modèle publicitaire RésiFlow</h4>
              <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14}}>
                {[
                  {icon:"🎯",title:"Ciblage contextuel",desc:"Ads affichées selon le type de page (charges → banques, maintenance → BTP)"},
                  {icon:"📊",title:"CPM garanti",desc:"Revenus par 1 000 impressions — sans dépendre des clics"},
                  {icon:"🔒",title:"Non-intrusif",desc:"Bannières discrètes entre les modules — expérience utilisateur préservée"},
                ].map(f => (
                  <div key={f.title} style={{background:"rgba(255,255,255,.08)",borderRadius:11,padding:14}}>
                    <p style={{fontSize:20,marginBottom:8}}>{f.icon}</p>
                    <p style={{color:"#fff",fontWeight:700,fontSize:13,marginBottom:5}}>{f.title}</p>
                    <p style={{color:"rgba(255,255,255,.5)",fontSize:11,lineHeight:1.5}}>{f.desc}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Campaigns table */}
            <div style={{background:C.card,borderRadius:16,boxShadow:"0 2px 14px rgba(11,19,51,.06)",overflow:"hidden"}}>
              <div style={{padding:"17px 22px",borderBottom:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <h4 style={{fontSize:15,fontWeight:700,color:C.text}}>Campagnes publicitaires</h4>
                <button className="btn" onClick={() => alert("📝 Création d'une nouvelle campagne — Module disponible en version Pro")}
                  style={{padding:"7px 16px",background:C.teal,color:"#fff",borderRadius:10,fontWeight:600,fontSize:12}}>
                  + Nouvelle campagne
                </button>
              </div>
              <table>
                <thead><tr><th>Annonceur</th><th>Type</th><th>Secteur</th><th>Statut</th><th>CPM</th><th>Impressions</th><th>Revenus</th><th>Période</th></tr></thead>
                <tbody>
                  {AD_CAMPAIGNS.map(c => (
                    <tr key={c.id}>
                      <td style={{fontWeight:600}}>{c.annonceur}</td>
                      <td style={{fontSize:11,color:C.muted}}>{c.type}</td>
                      <td><span style={{background:C.blueL,color:C.blue,padding:"2px 8px",borderRadius:7,fontSize:11,fontWeight:600}}>{c.secteur}</span></td>
                      <td><span style={{background:c.statut==="actif"?"#d1fae5":"#f3f4f6",color:c.statut==="actif"?"#065f46":"#6b7280",padding:"2px 8px",borderRadius:7,fontSize:11,fontWeight:600}}>{c.statut}</span></td>
                      <td style={{fontWeight:600}}>{c.CPM} MAD</td>
                      <td>{c.impressions.toLocaleString()}</td>
                      <td style={{fontWeight:700,color:C.green}}>{fmt(c.revenus)}</td>
                      <td style={{fontSize:11,color:C.muted}}>{fmtD(c.debut)} → {fmtD(c.fin)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div style={{padding:"12px 22px",background:C.bg,display:"flex",justifyContent:"flex-end",alignItems:"center",gap:10}}>
                <span style={{fontSize:13,color:C.muted}}>Total revenus publicitaires</span>
                <span style={{fontSize:16,fontWeight:800,color:C.green}}>{fmt(totalAdRev)}/mois</span>
              </div>
            </div>
          </div>
        )}

        {/* ── PROVIDERS ── */}
        {tab === "providers" && (
          <div className="fi">
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14,marginBottom:20}}>
              <Kpi icon="🔧" label="Total prestataires"  value={prestataires.length}                              color={C.blue}  />
              <Kpi icon="👑" label="Business"            value={prestataires.filter(p=>p.plan==="business").length} color={C.gold}  />
              <Kpi icon="⏳" label="En attente validation" value={providerRequests.length}                        color={C.red}   />
            </div>

            {providerRequests.length > 0 && (
              <div style={{background:C.card,borderRadius:16,padding:20,boxShadow:"0 2px 14px rgba(11,19,51,.06)",marginBottom:20}}>
                <h4 style={{fontSize:15,fontWeight:700,color:C.text,marginBottom:16}}>⏳ Demandes en attente de validation</h4>
                <div style={{display:"flex",flexDirection:"column",gap:10}}>
                  {providerRequests.map((request) => (
                    <div key={request.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"14px 16px",borderRadius:12,background:C.bg,border:`1px solid ${C.border}`}}>
                      <div>
                        <p style={{fontSize:14,fontWeight:700,color:C.text}}>{request.companyName}</p>
                        <p style={{fontSize:12,color:C.muted}}>{request.firstName} {request.lastName} · {request.email} · {request.serviceCategory}</p>
                      </div>
                      <div style={{display:"flex",gap:8}}>
                        <button className="btn" onClick={() => onApproveProvider(request.id)}
                          style={{padding:"7px 14px",background:"#d1fae5",color:"#065f46",borderRadius:9,fontWeight:700,fontSize:12}}>✓ Valider</button>
                        <button className="btn" onClick={() => onRejectProvider(request.id)}
                          style={{padding:"7px 14px",background:"#fee2e2",color:C.red,borderRadius:9,fontWeight:700,fontSize:12}}>✗ Refuser</button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div style={{background:C.card,borderRadius:16,boxShadow:"0 2px 14px rgba(11,19,51,.06)",overflow:"hidden"}}>
              <div style={{padding:"17px 22px",borderBottom:`1px solid ${C.border}`}}>
                <h4 style={{fontSize:15,fontWeight:700,color:C.text}}>Prestataires actifs</h4>
              </div>
              <table>
                <thead><tr><th>Nom</th><th>Catégorie</th><th>Ville</th><th>Plan</th><th>Note</th><th>Certifié</th></tr></thead>
                <tbody>
                  {prestataires.map(p => {
                    const pl = PLANS[p.plan] || PLANS.decouverte;
                    return (
                      <tr key={p.id}>
                        <td style={{fontWeight:600}}>{p.nom}</td>
                        <td style={{color:C.muted}}>{p.cat}</td>
                        <td style={{color:C.muted}}>{p.ville}</td>
                        <td><span className="plan-badge" style={{background:pl.bg,color:pl.color}}>{pl.icon} {pl.label}</span></td>
                        <td><span style={{color:C.gold,fontWeight:700}}>★ {p.note}</span></td>
                        <td>{p.certifié ? <span style={{color:C.green,fontWeight:700}}>✓ Certifié</span> : <span style={{color:C.muted}}>—</span>}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* ── USERS ── */}
        {tab === "subscribers" && (
          <div className="fi">
            <div style={{background:C.card,borderRadius:16,boxShadow:"0 2px 14px rgba(11,19,51,.06)",overflow:"hidden"}}>
              <div style={{padding:"17px 22px",borderBottom:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <h4 style={{fontSize:15,fontWeight:700,color:C.text}}>Tous les utilisateurs ({subscribers.length})</h4>
              </div>
              <table>
                <thead><tr><th>Type</th><th>Nom</th><th>Email</th><th>Plan / Statut</th></tr></thead>
                <tbody>
                  {subscribers.map((s) => (
                    <tr key={s.id}>
                      <td><span style={{background:s.type==="Prestataire"?C.tealL:C.blueL,color:s.type==="Prestataire"?C.teal:C.blue,padding:"2px 8px",borderRadius:7,fontSize:11,fontWeight:600}}>{s.type}</span></td>
                      <td style={{fontWeight:600}}>{s.name}</td>
                      <td style={{color:C.muted}}>{s.email}</td>
                      <td>{s.plan ? <span className="plan-badge" style={{background:PLANS[s.plan]?.bg,color:PLANS[s.plan]?.color}}>{PLANS[s.plan]?.icon} {PLANS[s.plan]?.label}</span> : <span style={{color:C.muted}}>Gratuit</span>}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* ── DEV PORTAL ── */}
        {tab === "dev" && (
          <div className="fi">
            <div style={{background:`linear-gradient(135deg,${C.navy},#1a2b7a)`,borderRadius:16,padding:24,marginBottom:20}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
                <div>
                  <h3 style={{color:"#fff",fontSize:18,fontWeight:800,fontFamily:"Syne",marginBottom:4}}>⚙️ Portail Développeur</h3>
                  <p style={{color:"rgba(255,255,255,.45)",fontSize:12}}>API REST · Webhooks · Sandbox · Documentation OpenAPI</p>
                </div>
                <button className="btn" onClick={() => alert("📖 Ouverture de la documentation Swagger UI")}
                  style={{padding:"9px 18px",background:"rgba(255,255,255,.1)",color:"#fff",borderRadius:10,fontWeight:600,fontSize:13,border:"1px solid rgba(255,255,255,.2)"}}>
                  📖 Swagger Docs
                </button>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12}}>
                {[["🔑","API Keys","3 clés actives"],["🪝","Webhooks",`${WEBHOOK_EVENTS.length} events`],["🧪","Sandbox","Activé"],["📊","Quota","14 200 / 50 000"]].map(([ic,l,v]) => (
                  <div key={l} style={{background:"rgba(255,255,255,.08)",borderRadius:11,padding:14,textAlign:"center"}}>
                    <p style={{fontSize:22,marginBottom:5}}>{ic}</p>
                    <p style={{color:"#fff",fontWeight:700,fontSize:13,marginBottom:2}}>{l}</p>
                    <p style={{color:"rgba(255,255,255,.45)",fontSize:11}}>{v}</p>
                  </div>
                ))}
              </div>
            </div>

            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:18}}>
              {/* API Keys */}
              <div style={{background:C.card,borderRadius:16,padding:22,boxShadow:"0 2px 14px rgba(11,19,51,.06)"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
                  <h4 style={{fontSize:14,fontWeight:700,color:C.text}}>🔑 Clés API</h4>
                  <button className="btn" onClick={() => alert("🔑 Nouvelle clé API générée !")}
                    style={{padding:"5px 12px",background:C.teal,color:"#fff",borderRadius:8,fontWeight:600,fontSize:11}}>
                    + Créer
                  </button>
                </div>
                {API_KEYS_DEMO.map(k => (
                  <div key={k.id} style={{padding:"12px 0",borderBottom:`1px solid ${C.border}`}}>
                    <div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}>
                      <span style={{fontWeight:600,color:C.text,fontSize:13}}>{k.nom}</span>
                      <span style={{background:C.blueL,color:C.blue,padding:"1px 7px",borderRadius:6,fontSize:10,fontWeight:700}}>{k.scope}</span>
                    </div>
                    <code style={{fontSize:11,color:C.muted,background:C.bg,padding:"3px 8px",borderRadius:5}}>{k.key}</code>
                    <div style={{display:"flex",gap:12,marginTop:5,fontSize:11,color:C.muted}}>
                      <span>Créée : {fmtD(k.created)}</span>
                      <span>Utilisée : {fmtD(k.lastUsed)}</span>
                      <span style={{color:C.blue,fontWeight:600}}>{k.calls.toLocaleString()} appels</span>
                    </div>
                  </div>
                ))}
              </div>

              {/* Webhooks */}
              <div style={{background:C.card,borderRadius:16,padding:22,boxShadow:"0 2px 14px rgba(11,19,51,.06)"}}>
                <h4 style={{fontSize:14,fontWeight:700,color:C.text,marginBottom:14}}>🪝 Webhooks & Events</h4>
                <div style={{marginBottom:14}}>
                  <p style={{fontSize:11,fontWeight:700,color:C.muted,textTransform:"uppercase",letterSpacing:".5px",marginBottom:8}}>Événements disponibles</p>
                  <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
                    {WEBHOOK_EVENTS.map(ev => (
                      <code key={ev} style={{fontSize:10,background:C.bg,color:C.navy,padding:"3px 8px",borderRadius:6,fontWeight:600}}>{ev}</code>
                    ))}
                  </div>
                </div>
                <p style={{fontSize:11,fontWeight:700,color:C.muted,textTransform:"uppercase",letterSpacing:".5px",marginBottom:8}}>Dernier log</p>
                {webhookLog.map(w => (
                  <div key={w.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"7px 0",borderBottom:`1px solid ${C.border}`,fontSize:12}}>
                    <div>
                      <code style={{fontSize:11,color:C.navy,fontWeight:600}}>{w.event}</code>
                      <p style={{fontSize:10,color:C.muted,marginTop:2}}>{w.ts}</p>
                    </div>
                    <span style={{background:w.statut.startsWith("200")?"#d1fae5":"#fee2e2",color:w.statut.startsWith("200")?"#065f46":C.red,padding:"2px 8px",borderRadius:6,fontSize:10,fontWeight:700}}>
                      {w.statut}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* API Endpoint preview */}
            <div style={{background:C.navy,borderRadius:16,padding:22,marginTop:18}}>
              <h4 style={{color:"#fff",fontSize:14,fontWeight:700,marginBottom:14}}>📋 Exemples d'endpoints</h4>
              <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:10}}>
                {[
                  {method:"GET",  path:"/v1/residences",             desc:"Liste des résidences"},
                  {method:"POST", path:"/v1/cotisations",            desc:"Créer un appel de fonds"},
                  {method:"GET",  path:"/v1/residents/:id/solde",    desc:"Solde d'un résident"},
                  {method:"POST", path:"/v1/maintenance",            desc:"Créer un ticket"},
                  {method:"GET",  path:"/v1/prestataires?cat=xxx",   desc:"Filtrer par catégorie"},
                  {method:"POST", path:"/v1/documents/upload",       desc:"Uploader un document"},
                ].map(e => (
                  <div key={e.path} style={{display:"flex",gap:8,alignItems:"center",background:"rgba(255,255,255,.05)",borderRadius:9,padding:"9px 12px"}}>
                    <span style={{background:e.method==="GET"?"#166534":"#1e40af",color:"#fff",fontSize:9,fontWeight:700,padding:"2px 6px",borderRadius:4,flexShrink:0,letterSpacing:".5px"}}>{e.method}</span>
                    <code style={{fontSize:11,color:C.teal,fontWeight:600}}>{e.path}</code>
                    <span style={{fontSize:11,color:"rgba(255,255,255,.4)",marginLeft:"auto"}}>{e.desc}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

/* ══════════════════════════════════════
   SYNDIC — RAPPORTS
══════════════════════════════════════ */

